import { createSelector } from 'reselect'

import { RootState } from '../types'

export const selectState = (state: RootState) => state.search

export const getSearchedCompanies = createSelector(selectState, x => x.companies)

export const getPageSize = createSelector(selectState, x => x.pageSize)

export const getPageCount = createSelector(selectState, x => x.pageCount)

export const getTotalCount = createSelector(selectState, x => x.totalCount)

export const isSearchLoading = createSelector(selectState, x => x.loading)
